
import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  AcceptedIcon,
  AssignedIcon,
  IncomingIcon,
  RejectedIcon,
} from "../../../assets/svgs/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import IncomingTC from "./IncomingTC";
import AssignedTC from "./AssignedTC";
import ApprovedTC from "./ApprovedTC";
import RejectedTC from "./RejectedTC";
import SentToL1TC from "./SentToL1TC";
import { countForTCAdmin } from "./TCL2AdminSlice";
import IncomingTCIndex from "./IncomingTCIndex";
import BuyerRejectedTC from "./BuyerRejectedTC";
import isAllowed from "../../../routing/isAllowed";
import HomeTC from "./HomeTC";


const TransactionL1Approver = () => {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(0);
  const { counts } = useSelector(state => state.TCL2Admin);

  const navigate = useNavigate();

  let countsForL2Admin = counts?.["L2-TC-ISSUER"]



  const getCounts = () => {
    try {
      setStatus("pending")
      dispatch(countForTCAdmin());
      setStatus("success")

    } catch (error) {
      setStatus("failed")

    }
  }

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <IncomingTC />,
    },
    {
      id: 1,
      component: () => <AssignedTC />,
    },
    {
      id: 2,
      component: () => <HomeTC />,
    },
    {
      id: 3,
      component: () => <RejectedTC />,
    },
    {
      id: 4,
      component: () => <BuyerRejectedTC />
    }

  ];

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTab", tabIndex);
  };

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, [page, isActive]);

  useEffect(() => {
    getCounts();
  }, [])

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem">
        <Grid
          width={"100%"}
          templateColumns="repeat(5, 1fr)"
          my={"1rem"}
          gap="0.8rem"
          height={"100%"}
        >
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#B1DFFF"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countsForL2Admin?.["INCOMING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Incoming TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#B8C9EA"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AssignedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countsForL2Admin?.["ASSIGNED"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Assigned TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#52BBFF"}
              color="#141D43"
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AcceptedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countsForL2Admin?.["APPROVE"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Approved TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 3 ? "#fff" : "#FE96A6"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 3
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(3);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <RejectedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countsForL2Admin?.["REJECT"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Rejected TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 4 ? "#fff" : "#B1DFFF"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 4
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(4);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countsForL2Admin?.["PENDING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Rejected Shipments
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {STEP_PAGES[page]?.component()}
      {/* child */}
    </Box>
  );
};

export default isAllowed(TransactionL1Approver);
